import { History } from 'types'

export const addClassName = (className?: string) => (className ? className : '')

export const equalArray = (arr1: History, arr2: History): boolean => {
  if (arr1.length !== arr2.length) {
    return false
  }

  for (let i = 0; i < arr1.length; i++) {
    for (let j = 0; j < arr1[i].length; j++) {
      if (arr1[i][j] !== arr2[i][j]) {
        return false
      }
    }
  }

  return true
}
